<div class="flex flex-col mb-8 cwe-section">
    <label for="email" class="form-label">CWE Rate</label>
    <input type="text" pInputText [(ngModel)]="cweRate" [imask]="percentMask" />
    <div class="flex gap-2 mt-8">

        <p-button label="Save Changes" [rounded]="true" (click)="saveChanges()" />
        <p-button label="Discard" [rounded]="true" severity="secondary" (click)="discardChanges()" />
    </div>
</div>